import styled, { keyframes } from 'styled-components'

const menuAnim = keyframes`
  from {
    transform: translateY(-2px);
    opacity: 0;
    box-shadow: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
    box-shadow:
      0 0 0 1px hsl(0deg 0% 0% / 0.035),
      0 1px 1px hsl(0deg 0% 0% / 0.015),
      0 2px 2px hsl(0deg 0% 0% / 0.015),
      0 4px 4px hsl(0deg 0% 0% / 0.015),
      0 8px 8px hsl(0deg 0% 0% / 0.015),
      0 16px 16px hsl(0deg 0% 0% / 0.015)
    ;
  }
`

const StyledHeader = styled.div`
  max-width: 600px;
  width: 100%;
  margin: 0 auto;
  padding: 0 20px;
  position: sticky;
  box-sizing: border-box;
  top: 0;
  z-index: ${({ theme }) => theme.elevation.fixed};

  header {
    padding: 10px 0;
    background-color: ${({ theme }) => theme.color.background};
    border-bottom: 1px solid ${({ theme }) => theme.color.gray[300]};
    display: flex;
    align-items: center;
    justify-content: space-between;

    .logo {
      display: flex;
      align-items: center;
      font-size: 25px;
      font-weight: 600;
      user-select: none;
      color: ${({ theme }) => theme.color.gray[800]};

      svg {
        height: 24px;
        margin-right: 4px;
      }
    }

    .avatar-btn {
      padding: 0;
      border-radius: 50%;
      border: 0;
      background-color: transparent;
    }
    
    .user-menu {
      position: absolute;
      top: calc(100% - 4px);
      right: 0;
      border-radius: 10px;
      box-shadow:
        0 0 0 1px hsl(0deg 0% 0% / 0.035),
        0 1px 1px hsl(0deg 0% 0% / 0.015),
        0 2px 2px hsl(0deg 0% 0% / 0.015),
        0 4px 4px hsl(0deg 0% 0% / 0.015),
        0 8px 8px hsl(0deg 0% 0% / 0.015),
        0 16px 16px hsl(0deg 0% 0% / 0.015)
      ;
      z-index: ${({ theme }) => theme.elevation.dropdown};
      background-color: ${({ theme }) => theme.color.background};
      padding: 6px;
      display: grid;
      animation: ${menuAnim} ease-in-out 0.2s forwards;

      button {
        border-radius: 4px;
        display: flex;
        padding: 6px;
        background-color: ${({ theme }) => theme.color.background};
        color: ${({ theme }) => theme.color.gray[600]};
        align-items: center;
        transition: 0.2s;

        svg {
          height: 20px;
          margin-right: 8px;
          color: ${({ theme }) => theme.color.gray[500]};

          path {
            stroke-width: 2px;
          }
        }

        &:hover {
          background-color: ${({ theme }) => theme.color.gray[100]};
        }
      }
    }
  }
`

export default StyledHeader
